import React, { Component } from 'react';
import { DashboardCard } from './DashboardCard';
import { BarChart3Icon, TruckIcon, DollarSignIcon, ClipboardCheckIcon, BadgeIcon, ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, MapIcon, GlobeIcon, UsersIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon } from 'lucide-react';
export function DashboardOverview() {
  return <div className="space-y-6" data-id="element-1189" data-mp="2m7iagmwh2f8b">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1190" data-mp="2h8xamol4txke">
        <StatCard title="Active Orders" value="22" trend="+4" trendLabel="from last month" trendUp={true} icon={<TruckIcon size={20} className="text-indigo-400" data-id="element-1192" data-mp="2cbx64i3xl2ve" />} color="indigo" data-id="element-1191" data-mp="2h6uavcu6gq2h" />
        <StatCard title="Total Quotes" value="2,392" trend="+152" trendLabel="from last month" trendUp={true} icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-1194" data-mp="23ayxtnmgm970" />} color="blue" data-id="element-1193" data-mp="27b9ebu7voi04" />
        <StatCard title="Warranty Claims" value="125" trend="-12" trendLabel="from last month" trendUp={false} icon={<ClipboardCheckIcon size={20} className="text-emerald-400" data-id="element-1196" data-mp="1iarh5eir5n0" />} color="emerald" data-id="element-1195" data-mp="5i33xt719vxn" />
        <StatCard title="Active Subscriptions" value="991" trend="+38" trendLabel="from last month" trendUp={true} icon={<BadgeIcon size={20} className="text-violet-400" data-id="element-1198" data-mp="3da1v39on73l6" />} color="violet" data-id="element-1197" data-mp="388m8veaqar17" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1199" data-mp="2za0t1qwn5q44">
        <DashboardCard title="Regional Distribution" icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1201" data-mp="33at14gts1oyt" />} className="lg:col-span-2" data-id="element-1200" data-mp="33a15j606jr8j">
          <div className="h-80 relative" data-id="element-1202" data-mp="3r16lrma18ljd">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1203" data-mp="3vyyprenyby3x">
              <div className="grid grid-cols-2 gap-4 w-full max-w-2xl px-6" data-id="element-1204" data-mp="3w12qjnqk0gzz">
                <RegionStat name="EUROPE" value="820" percentage={75} color="blue" data-id="element-1205" data-mp="3i721jlpem8ct" />
                <RegionStat name="AMERICA" value="180" percentage={45} color="indigo" data-id="element-1206" data-mp="3m83s7e599c36" />
                <RegionStat name="MENA" value="10" percentage={15} color="emerald" data-id="element-1207" data-mp="dt3hny226m37" />
                <RegionStat name="AFRICA" value="20" percentage={25} color="amber" data-id="element-1208" data-mp="iklm4w3aj4sx" />
                <RegionStat name="LATAM" value="160" percentage={40} color="rose" data-id="element-1209" data-mp="sg2c81w7pwm5" />
                <RegionStat name="ANZ" value="150" percentage={35} color="violet" data-id="element-1210" data-mp="sdpv1qya3qa5" />
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard title="Performance Overview" icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1212" data-mp="eg9n2b0c3oga" />} data-id="element-1211" data-mp="je2q4v6cc2cc">
          <div className="space-y-6" data-id="element-1213" data-mp="efrk6vj62bze">
            <div data-id="element-1214" data-mp="9h6isss6hm9d">
              <div className="flex justify-between mb-2" data-id="element-1215" data-mp="9hpvnv2z1kgj">
                <span className="text-sm text-blue-300" data-id="element-1216" data-mp="9jaqllt775ex">Orders Completion</span>
                <span className="text-sm font-medium text-white" data-id="element-1217" data-mp="4owrb8bf0e4z">78%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1218" data-mp="pe7ygz8sb49">
                <div className="bg-indigo-500 h-2 rounded-full" style={{
                width: '78%'
              }} data-id="element-1219" data-mp="3rvyylzldxh0r"></div>
              </div>
            </div>
            <div data-id="element-1220" data-mp="3hwzwkzv4kjmq">
              <div className="flex justify-between mb-2" data-id="element-1221" data-mp="3hwhrddqhiv2o">
                <span className="text-sm text-blue-300" data-id="element-1222" data-mp="3hz2wqcpzrt56">Quote Conversion</span>
                <span className="text-sm font-medium text-white" data-id="element-1223" data-mp="37sjhw9tdt8ki">42%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1224" data-mp="3cquqkh7xxd15">
                <div className="bg-blue-500 h-2 rounded-full" style={{
                width: '42%'
              }} data-id="element-1225" data-mp="3hqpfwgc2huk3"></div>
              </div>
            </div>
            <div data-id="element-1226" data-mp="3mo94oa6e5pqa">
              <div className="flex justify-between mb-2" data-id="element-1227" data-mp="2p2l89p9xr7er">
                <span className="text-sm text-blue-300" data-id="element-1228" data-mp="2p44pbi3f1mhl">
                  Warranty Resolution
                </span>
                <span className="text-sm font-medium text-white" data-id="element-1229" data-mp="2tzk0g2a1h4ab">92%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1230" data-mp="2yyob6xcm3a2r">
                <div className="bg-emerald-500 h-2 rounded-full" style={{
                width: '92%'
              }} data-id="element-1231" data-mp="33s9cozdeym6p"></div>
              </div>
            </div>
            <div data-id="element-1232" data-mp="2ban8i5246nv9">
              <div className="flex justify-between mb-2" data-id="element-1233" data-mp="2ba53aixh4zb7">
                <span className="text-sm text-blue-300" data-id="element-1234" data-mp="guy9of2isd2b">
                  Subscription Renewal
                </span>
                <span className="text-sm font-medium text-white" data-id="element-1235" data-mp="bwdkrbspxft6">86%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1236" data-mp="qkhv9shmal0v">
                <div className="bg-violet-500 h-2 rounded-full" style={{
                width: '86%'
              }} data-id="element-1237" data-mp="qmuhihuerhjq"></div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1238" data-mp="vjurh3udp4g4">
        <DashboardCard title="Top Dealers" icon={<UsersIcon size={20} className="text-blue-400" data-id="element-1240" data-mp="19jlygkmh9kkm" />} data-id="element-1239" data-mp="vjb6tfdcg1ye">
          <div className="space-y-4" data-id="element-1241" data-mp="19j3x59kykg5u">
            {['TEXAS INTERNATIONAL IRRIGATION', 'UWR', 'I-BEAM Irrigation', 'AQUADOC', 'NORTHERN IRRIGATION SYSTEMS'].map((dealer, index) => <div key={index} className="flex items-center" data-id="element-1242" data-mp="3ba79c3ahy2si" data-mpi={index}>
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-3" data-id="element-1243" data-mp="36bvx5lwqbg74">
                  <span className="text-white text-xs font-bold" data-id="element-1244" data-mp="1luwijvci71xl">
                    {dealer.split(' ').map(word => word[0]).join('')}
                  </span>
                </div>
                <div className="flex-1" data-id="element-1245" data-mp="1c4lfsc4k2ysa">
                  <div className="text-sm font-medium text-white" data-id="element-1246" data-mp="1c3imjxjrgk97">{dealer}</div>
                  <div className="flex items-center mt-1" data-id="element-1247" data-mp="1h23gjf8f67p7">
                    <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1248" data-mp="133dju0piia1d">
                      <div className="bg-blue-500 h-1.5 rounded-full" style={{
                    width: `${100 - index * 10}%`
                  }} data-id="element-1249" data-mp="135q7muhybemc"></div>
                    </div>
                    <span className="ml-2 text-xs text-blue-300" data-id="element-1250" data-mp="t70okyebjo4i">
                      {167 - index * 15}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </DashboardCard>
        <DashboardCard title="Recent Activity" icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1252" data-mp="2sh0i1olsipdg" />} data-id="element-1251" data-mp="2sibmlqn2815m">
          <div className="space-y-4" data-id="element-1253" data-mp="2r1nyqtv41so0">
            <ActivityItem title="New order received" description="Order #HX6AA6-3 from AGRICULTURAL SERVICES Inc" time="2 hours ago" icon={<TruckIcon size={16} className="text-indigo-400" data-id="element-1255" data-mp="2m44ixpirl7ty" />} iconBg="bg-indigo-500/20" data-id="element-1254" data-mp="2r2pn20150bno" />
            <ActivityItem title="Quote approved" description="Quote #DKEYFH-1 for $64,699.26" time="5 hours ago" icon={<CheckCircleIcon size={16} className="text-emerald-400" data-id="element-1257" data-mp="2d3g4itpgl5gj" />} iconBg="bg-emerald-500/20" data-id="element-1256" data-mp="2h51g8bq9bdp5" />
            <ActivityItem title="Warranty claim rejected" description="Claim #WC-2023-089 for missing parts" time="Yesterday" icon={<XCircleIcon size={16} className="text-rose-400" data-id="element-1259" data-mp="301ku1ec09ps1" />} iconBg="bg-rose-500/20" data-id="element-1258" data-mp="39tgswrlx1jxb" />
            <ActivityItem title="New subscription activated" description="iCRcell subscription for VK SALES & SERVICE" time="2 days ago" icon={<BadgeIcon size={16} className="text-violet-400" data-id="element-1261" data-mp="3sidm0s5ku6dy" />} iconBg="bg-violet-500/20" data-id="element-1260" data-mp="2w07nt3503kkl" />
            <ActivityItem title="Quote converted to order" description="Quote #ZAK096-2 for $189,847.68" time="3 days ago" icon={<DollarSignIcon size={16} className="text-blue-400" data-id="element-1263" data-mp="1a9su1cfnbiwr" />} iconBg="bg-blue-500/20" data-id="element-1262" data-mp="3nqvpcgal6rys" />
          </div>
        </DashboardCard>
        <DashboardCard title="Issue Analysis" icon={<ClipboardCheckIcon size={20} className="text-blue-400" data-id="element-1265" data-mp="1j8xtqm2y1iai" />} data-id="element-1264" data-mp="1f841xhmdrjcc">
          <div className="space-y-4" data-id="element-1266" data-mp="1jbsdsci1p13e">
            <div className="flex items-center justify-between mb-2" data-id="element-1267" data-mp="1o8sjgmazg1tz">
              <h3 className="text-sm font-medium text-blue-300" data-id="element-1268" data-mp="1t7myre9qr89c">Top Issues</h3>
              <button className="text-blue-400 hover:text-white" data-id="element-1269" data-mp="1t5ix72zbelc8">
                <MoreHorizontalIcon size={16} data-id="element-1270" data-mp="1y5f2r6nnuktw" />
              </button>
            </div>
            <IssueItem name="Leaks and Seal Damage" count={40} percentage={40} color="blue" data-id="element-1271" data-mp="22yhncpagmjxy" />
            <IssueItem name="Electrical Components" count={18} percentage={18} color="amber" data-id="element-1272" data-mp="26z9zbqapv2xx" />
            <IssueItem name="Wheel and Tire Issues" count={30} percentage={30} color="red" data-id="element-1273" data-mp="2bywa7t32o73k" />
            <IssueItem name="Engine Failures" count={25} percentage={25} color="rose" data-id="element-1274" data-mp="2gwoeznotfnp6" />
            <IssueItem name="Structure Issues" count={30} percentage={30} color="emerald" data-id="element-1275" data-mp="1rtsitne0mgr6" />
            <IssueItem name="Manufacturing Defects" count={35} percentage={35} color="indigo" data-id="element-1276" data-mp="1muy0emjymu7l" />
          </div>
        </DashboardCard>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  trend,
  trendLabel,
  trendUp,
  icon,
  color
}) {
  const colors = {
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30',
    indigo: 'from-indigo-500/20 to-indigo-600/20 border-indigo-500/30',
    emerald: 'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
    violet: 'from-violet-500/20 to-violet-600/20 border-violet-500/30'
  };
  return <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-5`} data-id="element-1277" data-mp="1hx5xkxhs1nom">
      <div className="flex justify-between items-start mb-4" data-id="element-1278" data-mp="1d4ct8aq80hd2">
        <div className="p-2 rounded-lg bg-slate-800/50" data-id="element-1279" data-mp="pfbszarjkciv">{icon}</div>
        <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${trendUp ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`} data-id="element-1280" data-mp="pdh4jmh2a2a1">
          {trendUp ? <ArrowUpIcon size={12} className="mr-1" data-id="element-1281" data-mp="b8gw82tye5qf" /> : <ArrowDownIcon size={12} className="mr-1" data-id="element-1282" data-mp="g0i2970j3080" />}
          {trend}
        </div>
      </div>
      <div className="text-2xl font-bold text-white mb-1" data-id="element-1283" data-mp="1bvld0v960eo">{value}</div>
      <div className="text-sm text-blue-300" data-id="element-1284" data-mp="19rafyyxs14w">{title}</div>
      <div className="mt-3 text-xs text-blue-400" data-id="element-1285" data-mp="6a5hpespr71v">{trendLabel}</div>
    </div>;
}
function RegionStat({
  name,
  value,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    rose: 'bg-rose-500',
    violet: 'bg-violet-500'
  };
  return <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-1286" data-mp="k4g25jxogf24">
      <div className="flex justify-between items-center mb-2" data-id="element-1287" data-mp="p0n99g1t7wln">
        <span className="text-sm font-medium text-white" data-id="element-1288" data-mp="34skkw2wf49uu">{name}</span>
        <span className="text-sm text-blue-300" data-id="element-1289" data-mp="34r9h432z323q">{value}</span>
      </div>
      <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1290" data-mp="39sqf9qu2oagm">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1291" data-mp="24ea4kudnc4d7"></div>
      </div>
    </div>;
}
function ActivityItem({
  title,
  description,
  time,
  icon,
  iconBg
}) {
  return <div className="flex" data-id="element-1292" data-mp="1uoyxtee8fbsh">
      <div className={`w-8 h-8 rounded-full ${iconBg} flex items-center justify-center mr-3 flex-shrink-0`} data-id="element-1293" data-mp="1unnu1ekse41d">
        {icon}
      </div>
      <div data-id="element-1294" data-mp="1lnim93bol3mo">
        <div className="text-sm font-medium text-white" data-id="element-1295" data-mp="1lnsdsvcdjiuh">{title}</div>
        <div className="text-xs text-blue-300" data-id="element-1296" data-mp="1lplnykm74l78">{description}</div>
        <div className="text-xs text-slate-400 mt-1" data-id="element-1297" data-mp="1qndf3cf0o3ad">{time}</div>
      </div>
    </div>;
}
function IssueItem({
  name,
  count,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    red: 'bg-red-500',
    rose: 'bg-rose-500'
  };
  return <div data-id="element-1298" data-mp="361jb4sv94mv8">
      <div className="flex justify-between mb-1" data-id="element-1299" data-mp="3b2gnupxhsopc">
        <span className="text-xs text-blue-300" data-id="element-1300" data-mp="3b15kgr7yliyr">{name}</span>
        <span className="text-xs font-medium text-white" data-id="element-1301" data-mp="zek9d87m0ou6">{count}</span>
      </div>
      <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1302" data-mp="ug0nt8wxhf2c">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1303" data-mp="uhtvmrja25bx"></div>
      </div>
    </div>;
}